import EssayEditor from "../../essay-editor/app";
import { useEffect, useRef } from "preact/hooks";

/**
 * @param {{content: string, editorType: 'none' | 'basic', showEquationEditorButton: boolean, updateContent: function(string):void}} props
 */
export default function EssayEditorComponent(props) {
    const editorContainerRef = useRef();
    const equationEditorContainerRef = useRef();

    useEffect(() => {
        if (!editorContainerRef.current || !equationEditorContainerRef.current) {
            return;
        }

        let editor = new EssayEditor({
            editorType: props.editorType,
            showEquationEditorButton: props.showEquationEditorButton,
            onAutoSave: (content) => {props.updateContent(content)},
            initialData: props.content,
            editorContainerElement: editorContainerRef.current,
            equationEditorContainerElement: equationEditorContainerRef.current,
        });

        return () => {
            editor.destroy();
        }
    }, []);

    return <>
        <div ref={equationEditorContainerRef}></div>
        <div class="essay-response" ref={editorContainerRef}></div>
    </>
}